import Swiper from 'swiper';
import { EffectFade, Navigation, Manipulation, Thumbs, Controller } from 'swiper/modules';

const AboutPage = {
  // Inicializa os Swipers
  initSwipers: function () {
    const { setupSwiperEvents } = AboutPage;
    const datasSwiperEl = document.querySelector('.content-datas .container.swiper');
    const historiasSwiperEl = document.getElementById('historia');

    if (datasSwiperEl && historiasSwiperEl) {
      const datasSwiper = new Swiper(datasSwiperEl, {
        modules: [Navigation, Controller],
        slidesPerView: 1,
        spaceBetween: 0,
        slideToClickedSlide: true,
        allowTouchMove: true,
        centeredSlides: false,
        navigation: {
          nextEl: '.content-datas .next',
          prevEl: '.content-datas .prev',
        },
        breakpoints: {
          768: {
            centeredSlides: true,
            slidesPerView: 3,
            spaceBetween: 10,
          }
        }
      });

      const historiasSwiper = new Swiper(historiasSwiperEl, {
        modules: [Manipulation, EffectFade, Navigation, Thumbs, Controller],
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 500,
        allowTouchMove: true,
        watchSlidesProgress: true,
      });

      // Configura o controle bidirecional
      datasSwiper.controller.control = historiasSwiper;
      historiasSwiper.controller.control = datasSwiper;

      setupSwiperEvents(datasSwiper, datasSwiperEl);
    }
  },

  // Configura eventos do Swiper
  setupSwiperEvents: function (datasSwiper, datasSwiperEl) {
    datasSwiper.on('slideChange', function () {
      const slides = datasSwiperEl.querySelectorAll('.data');
      slides.length > 0 && slides.forEach((slide, index) => {
        if (index == datasSwiper.activeIndex) {
          slide.classList.add('swiper-slide-active');
        } else {
          slide.classList.remove('swiper-slide-active');
        }
      });
    });

    const dataSlides = datasSwiperEl.querySelectorAll('.data');
    dataSlides.length > 0 && dataSlides.forEach((slide, index) => {
      slide.addEventListener('click', function () {
        datasSwiper.slideTo(index);
        dataSlides.forEach((s) => s.classList.remove('swiper-slide-active'));
        slide.classList.add('swiper-slide-active');
      });
    });

    const datasElement = document.querySelector('.datas');
    datasElement && datasElement.addEventListener('wheel', function (e) {
      e.preventDefault();
      if (e.deltaY > 0) {
        datasSwiper.slideNext();
      } else {
        datasSwiper.slidePrev();
      }
    });
  },

  // Configura a navegação por hash
  setupHashNavigation: function () {
    if (location.hash && location.hash !== "") {
      const id = location.hash;
      const element = document.querySelector(id);

      if (element) {
        const offset = element.offsetTop;

        const links = document.querySelectorAll('.links .link');
        links.length > 0 && links.forEach(link => {
          link.classList.remove('active');
        });

        const currentLink = document.querySelector(`[href="${id}"]`);
        if (currentLink) {
          currentLink.closest('.link').classList.add('active');
        }

        setTimeout(() => {
          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }, 1000);
        
      }
    }

    const navLinks = document.querySelectorAll('.links a');
    navLinks.length > 0 && navLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const id = this.getAttribute('href');
        const element = document.querySelector(id);

        if (element) {
          const offset = element.offsetTop;

          const links = document.querySelectorAll('.links .link');
          links.length > 0 && links.forEach(link => {
            link.classList.remove('active');
          });

          this.closest('.link').classList.add('active');

          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }
      });
    });
  },

  // Configura eventos de scroll
  setupScrollEvents: function () {
    window.addEventListener('scroll', function () {
      const windowHeight = window.innerHeight;
      const adjust = windowHeight / 2;
      const scrollTop = window.scrollY;
      const viewportBottom = scrollTop + windowHeight;

      const sections = document.querySelectorAll('section');
      sections.length > 0 && sections.forEach(section => {
        if (!section.classList.contains('is-active')) {
          const elementTop = section.offsetTop + adjust;
          const elementBottom = elementTop + section.offsetHeight;

          if (elementBottom > scrollTop && elementTop < viewportBottom) {
            const links = document.querySelectorAll('.links .link');
            links.length > 0 && links.forEach(link => {
              link.classList.remove('active');
            });

            const sectionId = section.getAttribute('id');
            const sectionLink = document.querySelector(`[href="#${sectionId}"]`);
            if (sectionLink) {
              sectionLink.closest('.link').classList.add('active');
            }
          }
        }
      });

      const videos = document.querySelectorAll('.video');
      videos.length > 0 && videos.forEach(video => {
        if (!video.classList.contains('play')) {
          const elementTop = video.offsetTop + adjust;
          const elementBottom = elementTop + video.offsetHeight;

          if (elementBottom > scrollTop && elementTop < viewportBottom) {
            const iframe = video.querySelector('iframe');
            if (iframe) {
              if (!iframe.src.includes('autoplay=1')) {
                if (iframe.src.includes('?')) {
                  iframe.src += '&autoplay=1';
                } else {
                  iframe.src += '?autoplay=1';
                }
              }
              video.classList.add('play');
            }
          }
        }
      });
    });
  },

  init: function () {
    const { initSwipers, setupHashNavigation, setupScrollEvents } = AboutPage;

    initSwipers();
    setupHashNavigation();
    setupScrollEvents();
  }
};

AboutPage.init();

export default AboutPage;